import React from 'react';
import './Header.css';

const Header = () => {
  return (
    <header className="header">
      <h1>AI风格图片转换器</h1>
      <p>上传图片，将其转换为不同的艺术风格</p>
    </header>
  );
};

export default Header; 